import axiosClient from './axiosClient';

export const getAdmins = (params?: Record<string, any>) => {
    return axiosClient.get('/admins', { params });
};

export const createAdmin = (data: Record<string, any>) => {
    return axiosClient.post('/admins', data);
};

export const updateAdmin = (id: string, data: Record<string, any>) => {
    return axiosClient.put(`/admins/${id}`, data);
};

export const deleteAdmin = (id: string) => {
    return axiosClient.delete(`/admins/${id}`);
};

export const uploadAdminAvatar = (id: string, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return axiosClient.post(`/admins/${id}/avatar`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};
export const getDashboardStats = () => {
    return axiosClient.get('/admins/dashboard/stats');
};

export const getAdminSubmissions = (params?: Record<string, any>) => {
    return axiosClient.get('/admins/submissions', { params });
};

export const getSubmissionDetail = (submissionId: string) => {
    return axiosClient.get(`/admins/submissions/${submissionId}`);
};

export const submitGrade = (submissionId: string, data: { score: number, feedback: string }) => {
    return axiosClient.patch(`/admins/submissions/${submissionId}/grade`, data);
};

export const getAdminTimetable = () => {
    return axiosClient.get('/admins/dashboard/timetable');
};

export const generateAIGradingSuggestion = (submissionId: string) => {
    return axiosClient.post(`/admins/submissions/${submissionId}/ai-grading`);
};
